import {DomainSection, RecommendationContext, TagScore} from '@/store/state/global.types';
import {UserActivityCategoryEnum, CandidatePoiItem} from '@mobi-components/global-solution';
import {Offer} from '@mobi-components/amex-poi-details-view';
import {Dictionary} from 'vue-router/types/router';
export interface FilterSection {
  id: UserActivityCategoryEnum;
  name: string;
  options: FilterTag[];
}

export interface FilterTag {
  id: string;
  domain: UserActivityCategoryEnum;
  domainSection: DomainSection;
  parent: string;
  name: string;
  value: boolean;
  disabled?: boolean;
}

export interface ILocationValue {
  formatted_address: string;
  name: string;
}

export interface MatchedTag {
  isBoolean: boolean;
  value: number;
  name: string;
  id: string;
}

export interface TripOption extends Omit<RecommendationContext, 'images' | 'price'> {
  id: string;
  total: number;
  match: number;
  matchedTags: MatchedTag[];
  name: string;
  contextName: string;
  images: string[];
  artifitial: boolean;
  originId?: string;
  trip: boolean;
  theme: string | null;
}
export interface SuggestionGroup {
  contexts: RecommendationContext[];
  theme: string;
  tag: string;
}

export interface RecommendationsContextWithOffers extends RecommendationContext {
  offers: Offer[];
}

export interface SuggestionPois {
  pois: RecommendationsContextWithOffers[];
  all_poi_ids: string[];
  theme: string;
  types: string[];
}

export interface ContextWithPois {
  context: CandidatePoiItem;
  pois: string[];
}

export interface SuggestionGroupResponse {
  results: SuggestionGroup[];
  context_trips: ContextWithPois[];
  attributes: Dictionary<Dictionary<TagScore>>;
}

export const TripWayTypes = {
  roundTrip: 'Round Trip',
  oneWay: 'One way',
  multiCity: 'Multi city',
};
